import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  GoogleMapsLoaderService,
  GoogleMapsLoaderServiceConfig,
} from './google-maps-loader.service';
import { GoogleMapsService } from './google-maps.service';

export function provideGoogleMapsDataAccess(opts: {
  loadConfig: () => GoogleMapsLoaderServiceConfig;
}): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: GoogleMapsLoaderServiceConfig,
      useFactory: opts.loadConfig,
    },
    GoogleMapsLoaderService,
    GoogleMapsService,
  ]);
}
